import React from 'react';
import { Box, Typography } from '@mui/material';
import PortalPoshakaHeaderCluster from './PortalPoshakaHeaderCluster';

/**
 * Page title for portal routes with Poshaka ribbon + benefits on the same row (right-aligned).
 * @param {string} title
 * @param {string} [imageUrl] - Optional product / line image shown beside the title
 * @param {string} [imageAlt]
 * @param {boolean} [showPoshakaCluster=true] - Set false on routes outside PortalLayout (e.g. public /donate) where PortalPoshakaProvider is not mounted.
 */
export default function PortalPageHeader({ title, imageUrl, imageAlt, showPoshakaCluster = true }) {
  const [imageFailed, setImageFailed] = React.useState(false);
  React.useEffect(() => {
    setImageFailed(false);
  }, [imageUrl]);

  const showImage = Boolean(imageUrl && String(imageUrl).trim() && !imageFailed);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
        gap: { xs: 1.5, sm: 2 },
        mb: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          minWidth: 0,
          flex: { sm: '1 1 auto' },
        }}
      >
        {showImage ? (
          <Box
            component="img"
            src={imageUrl}
            alt={imageAlt || ''}
            onError={() => setImageFailed(true)}
            sx={{
              width: { xs: 44, sm: 52 },
              height: { xs: 44, sm: 52 },
              borderRadius: 1.5,
              objectFit: 'cover',
              flexShrink: 0,
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'grey.50',
            }}
          />
        ) : null}
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600, m: 0, minWidth: 0 }}>
          {title}
        </Typography>
      </Box>
      {showPoshakaCluster ? (
        <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-end' }, alignItems: 'center' }}>
          <PortalPoshakaHeaderCluster />
        </Box>
      ) : null}
    </Box>
  );
}
